import { Component, Input } from '@angular/core';
import { Day, Flight } from 'src/main/webapp/assets/models/iter.model';

/**ToDo Documentazione */
@Component({
  selector: 'app-recap-flights',
  styleUrls: ['./recap-flights.component.scss'],
  templateUrl: './recap-flights.component.html'
})
export class RecapFlightsComponent {
  @Input() public day: Day | undefined;
  @Input() public serviceIcons: any;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public getFlightRecap(flight: Flight) {
    const airportNameStart = flight.segments[0].departure.airportName;
    const airportNameEnd = flight?.segments[flight.segments.length - 1]?.arrival?.airportName;

    return  `${airportNameStart} - ${airportNameEnd}`;
  }
}
